(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.section = document.querySelector('.section-header');
      this.wrapper = document.getElementById('HeaderWrapper');
      this.root = document.getElementById('StickyHeaderRoot');

      this.stickyType = this.getAttribute('data-sticky-type') || 'on-scroll-up';
      this.isAlways = this.stickyType === 'always';
      this.isReduce = this.stickyType === 'reduce-logo-size';

      // always / reduce は常時 sticky
      if (this.isAlways || this.isReduce) {
        this.section.classList.add('shopify-section-header-sticky');
      }

      this.MIN_DELTA = 5; // 微小スクロール無視
      this.currentScrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);

      // 初期背景モード
      this.applyBackground(this.currentScrollTop);

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    getScrollThreshold() {
      const desktop = Number(this.root?.dataset?.desktopThreshold || 550);
      const mobile = Number(this.root?.dataset?.mobileThreshold || 450);
      const isMobile = window.matchMedia('(max-width: 990px)').matches;
      return isMobile ? mobile : desktop;
    }

    swapColorScheme(useTransparent) {
      if (!this.wrapper) return;
      const def = this.root.dataset.defaultColorScheme;
      const tr = this.root.dataset.transparentColorScheme;
      this.wrapper.classList.remove(def, tr);
      this.wrapper.classList.add(useTransparent ? tr : def);
    }

    makeTransparent() {
      this.swapColorScheme(true);
      this.wrapper.classList.add('header-wrapper--overlay', 'header-wrapper--transparent');
      this.root.classList.add('is-transparent');
    }

    makeSolid() {
      this.swapColorScheme(false);
      this.wrapper.classList.remove('header-wrapper--transparent');
      this.root.classList.remove('is-transparent');
    }

    applyBackground(y) {
      const threshold = this.getScrollThreshold();
      const transparentEnabled = this.root?.dataset?.transparentEnabled === 'true';
      if (transparentEnabled && y <= threshold) this.makeTransparent();
      else this.makeSolid();
    }

    onScroll() {
      const y = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
      const dy = y - this.currentScrollTop;
      const up = dy < -this.MIN_DELTA;
      const down = dy > this.MIN_DELTA;

      if (this.isAlways || this.isReduce) {
        // 表示は常時、背景は閾値で透明⇄通常
        this.applyBackground(y);
        // reduce はロゴ縮小クラスを閾値で切替
        if (this.isReduce) {
          if (y > this.getScrollThreshold()) this.section.classList.add('scrolled-past-header');
          else this.section.classList.remove('scrolled-past-header');
        }
        this.currentScrollTop = y;
        return;
      }

      // on-scroll-up モード
      const threshold = this.getScrollThreshold();
      if (y <= threshold) {
        this.applyBackground(y); // TOP付近は透明（設定ON時）
        this.reveal();
      } else {
        this.makeSolid();
        if (down) this.hide();
        else if (up) this.reveal();
      }

      this.currentScrollTop = y;
    }

    hide() { this.section.classList.add('shopify-section-header-hidden'); }

    reveal() {
      this.section.classList.add('shopify-section-header-sticky');
      this.section.classList.add('animate');
      this.section.classList.remove('shopify-section-header-hidden');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
